<template>
	<div id="voiceScene">
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="功能学习" name="zero">
		    <div class="iframe-box">
		    	<iframe src="/tjkStudy/hawkeye/voiceExam" frameborder="0" width="100%" height="100%"></iframe>
		    </div>
	    </el-tab-pane>
	    <el-tab-pane label="语音对练" name="first">
		    <div class="priContent">
		    	<div class="prictice">
	          <div class="imgBox">
	            <img src="../../../static/icon_voice.png" alt="" />
	          </div>
	          <div v-if="step == 'first'">
	            <div v-for="(item, i) in priList" :key="i">
	              <div class="title">{{item.title}}：</div>
	              <div :class="item.title == '操作手册' ? 'value in-block' : 'value'" v-for="(priItem, index) in item.tips" :key="index">{{priItem.value}}</div>
	              <a class="goToNewAdd" style="color:red;" href="https://tjhawkeye.oss-cn-beijing.aliyuncs.com/ts/%E5%AF%B9%E7%BB%83%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf" target="_blank" v-if="item.title == '操作手册'">点击查看操作手册</a>
	            </div>
	            <div class="konwBox">
	              <div class="knowBtn" @click="showKnow">我已知晓</div>
	            </div>
	          </div>
	          <div v-else-if="step == 'second'" class="pricComfir">
	            <div class="comTitle"> 请输入对练搭档的9位数淘金号： </div>
	            <div class="content">
	              <el-input class="input" v-model="input" placeholder="请输入对练搭档的淘金号"></el-input>
	              <div :class="input ? 'comfirmBtn ActiveComBtn' : 'comfirmBtn'" @click="goToPrict">确定</div>
	            </div>
	          </div>
	          <div class="handBox" v-else-if="step == 'handing'">
	            <div class="stOrNew">
	              <div class="stopPrict defaultBtn" @click="stopPrict">停止对练</div>
	              <div class="newPrict defaultBtn" @click="newPrict">继续对练</div>
	            </div>
	          </div>
	        </div>
				</div>
	    </el-tab-pane>
	    <!--
	    <el-tab-pane label="语音陪练" name="second">
	    	<template v-if="!list.length">
		      <p class="tj-shift-notice">暂无记录</p>
		    </template>
		    <template v-else>
		    	<div class="scene-box">
						<div class="scene" v-for="(l, key) in list">
							<a @click="toDetail(l.id)">
								<div :style="style(l.imageUrl)" class="zoomImage"></div>
								<div class="content">
									<p class="title" :title="l.name">{{l.name}}</p>
									<div v-if="l.exerciseStatus == 1" class="btn" style="background-color: #FF0000;" @click.stop="stopTeacherPrict">结束陪练</div>
									<div v-else class="btn">点击进入</div>
								</div>
							</a>
						</div>
					</div>
				</template>
	    </el-tab-pane>-->
	    <el-tab-pane label="场景考核" name="third">
	    	<template v-if="!kaoheList.length">
		      <p class="tj-shift-notice">暂无记录</p>
		    </template>
		    <template v-else>
		    	<div class="scene-box">
						<div class="scene" v-for="(l, key) in kaoheList">
							<a @click="toKaoheDetail(l.id)">
								<div :style="style(l.imageUrl)" class="zoomImage"></div>
								<div class="content">
									<p class="title" :title="l.name">{{l.name}}</p>
									<div v-if="l.exerciseStatus == 1" class="btn" style="background-color: #FF0000;" @click.stop="stopKaohePrict">结束考核</div>
									<div v-else class="btn">点击进入</div>
								</div>
							</a>
						</div>
					</div>
				</template>
	    </el-tab-pane>
	  </el-tabs>
	  <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <span>是否确定与{{partner.realName}}({{partner.tjkNumber}})进行语音对练?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="clearSchedule">确 定</el-button>
      </span>
  	</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tjkId: '',
				activeName: 'zero',
				list: [],
				step: 'first',
        input: '',
        priList: [
          {
            title: '对练目的',
            tips: [
              {
                value:'1、熟悉小助手外呼操作步骤;'
              },
              {
                value:'2、与搭档进行话术对练。'
              }
            ]
          },
          {
            title: '必备条件',
            tips: [
              {
                value:'1、有对练搭档（一般老师会分组，若未分组，请自行在群内找搭档）；'
              },
              {
                value:'2、你的对练搭档也进入了语音对练。'
              }
            ]
          },
          {
            title: '操作手册',
            tips: [
              {
                value:'1、请先查看语音对练操作手册，然后再进行练习。'
              }
            ]
          }
        ],
        dialogVisible: false,
        partner: {},
        kaoheList: []
			}
		},
		created() {
			this.getCustomerUser();
		},
		mounted() {
			this.getList();
			this.getKaoheList();
		},
		methods: {
			style(iconUrl) {
	      return {
	        backgroundImage: 'url(' + iconUrl + ')'
	      }
	    },
	    handleClick() {

	    },
			getList() {
				this.$http.post(API_ROOT.college + '/voiceScene/list').then(response=>{
					var result = response.data;
					if(result.success) {
						this.list = result.data;
					}else {
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			/*toDetail(id) {
				this.$http.post(API_ROOT.college + '/voiceExerciseCustomer/accompanyReady', {'id': id}).then(response=>{
					var result = response.data;
					if(result.success) {
						this.toSign(id);
					}else {
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},*/
			toSign(id) {
				this.$http.get('http://127.0.0.1:26789/api/npg/start?id='+id).then(response=> {
	        var result = response.data;
	        if(result.success) {
	          
	        }
	      },response=> {
	        
	      })
	    },
	    getKaoheList() {
				this.$http.post(API_ROOT.college + '/voiceScene/listExamScene').then(response=>{
					var result = response.data;
					if(result.success) {
						this.kaoheList = result.data;
					}else {
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			toKaoheDetail(id) {
				this.$http.post(API_ROOT.college + '/voiceExerciseCustomer/examReady', {'id': id}).then(response=>{
					var result = response.data;
					if(result.success) {
						this.toSign(id);
					}else {
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			stopKaohePrict() {
				this.$http.get(API_ROOT.college + `/voiceExerciseCustomer/endExamExercise?assitantTjkId=${this.tjkId}&returnAllData=1`).then((result) => {
				  if(result.data.success) {
					this.getKaoheList();
				  }
        		});
			},
	    //查询淘金客信息
			getCustomerUser() {
				this.$http.get('/customer/action/currentUser/customerUser').then(response=>{
					var result = response.data;
					if(result.success) {
						this.tjkId = result.data.id;
						this.isHasPri();
					}else{
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
	    showKnow() {
        this.step = 'second';
      },
      isHasPri() {
        this.$http.get(API_ROOT.college + `/voice/exercise/existExercise?assitantTjkId=${this.tjkId}&returnAllData=1`).then((result) => {
          if(result.data.success && result.data.data) {
            this.step = 'handing';
          }else {
            this.step = 'first';
          }
        });
      },
      goToPrict() {
        var patrn = /^(-)?\d+(\.\d+)?$/;
        if(!patrn.exec(this.input)) {
            this.$message({
              message: '请输入正确的淘金号',
              type: 'error'
            });
            return;
        }
        if(this.input && this.input.length < 9) {
            this.$message({
              message: '淘金号长度至少为9位',
              type: 'error'
            });
            return;
        }

        //查询是否存在当前淘金号
        this.$http.get(API_ROOT.tjkuser + `/tjk/queryTjkList?tjkParam=${this.input}&returnAllData=1`).then((result) => {
          if(result.data.data.length) {
            this.partner = result.data.data[0];
            this.dialogVisible = true;
          }else {
            this.$message({ message: '未找到对应的对练伙伴，请重新输入淘金号', type: 'error'});
          }
        });
        // 打开打卡，然后展示正在练习
      },
      stopPrict() {
        this.$http.get(API_ROOT.college + `/voice/exercise/endExercise?assitantTjkId=${this.tjkId}&returnAllData=1`).then((result) => {
          if(result.data.success) {
            this.step = 'first';
          }
        });
      },
      /*stopTeacherPrict() {
        this.$http.get(API_ROOT.college + `/voiceExerciseCustomer/endExercise?assitantTjkId=${this.tjkId}&returnAllData=1`).then((result) => {
          if(result.data.success) {
            this.getList();
          }
        });
      },*/
      newPrict() {
        this.step = 'second';
      },
      //清空排版数据
      clearSchedule() {
        this.$http.get('http://127.0.0.1:26688/api/SignIn/clearScheduleCache').then((res) => {})
        this.sureGoToPri();
      },
      sureGoToPri() {
        this.$http.get(API_ROOT.college + `/voice/exercise/ready?tjkId=${this.partner.id}&assitantTjkId=${this.tjkId}&returnAllData=1`).then((result) => {
          if(result.data.success) {
            this.getHawkeye();
            this.input = '';
            this.step = 'handing';
            this.dialogVisible = false;
          }else {
            this.$message({
              message: result.data.msg,
              type: 'error'
            });
          }
        });
      },
      //调用小助手
	    getHawkeye() {
	      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=').then(response=> {
	        var result = response.data;
	        if(result.success) {
	          
	        }
	      },response=> {
	        
	      })
	    },
      handleClose(done) {
        this.$confirm('确认关闭？').then(res => {
          done();
        }).catch(res => {});
      }
		}
	}
</script>

<style lang="less" scoped>
.iframe-box {
  width: 100%;
  height: 100%;
}
.priContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  .prictice {
	  .imgBox {
	    display: flex;
	    justify-content: center;
	  }
	  .title {
	    font-weight: 700;
	    font-size: 16px;
	    margin-top: 10px;
	  }
	  .value {
	    margin-top: 10px;
	    color: #80858B;
	  }
	  .in-block {
	    display: inline-block;
	    margin-right: 10px;
	  }
	  .konwBox {
	    margin-top: 30px;
	    display: flex;
	    justify-content: center;
	  }
	  .knowBtn {
	    width: 150px;
	    cursor: pointer;
	    height: 40px;
	    line-height: 40px;
	    background-color: #118EF2;
	    color: #fff;
	    border-radius: 15px;
	    text-align: center;
	  }
	  .pricComfir {
	    width: 100%;
	    margin-top: 20px;
	  }
	  .comTitle {
	    font-weight: 700;
	    margin-bottom: 15px;
	  }
	  .content {
	  	display: flex;
	  }
	  .input {
	    .el-input__inner {
	      border-radius: 10px;
	      width: 320px;
	    }
	  }
	  .comfirmBtn {
	    margin-left: 15px;
	    width: 170px;
	    line-height: 40px;
	    background-color: #D3D3D3;
	    text-align: center;
	    color: #fff;
	    border-radius: 15px;
	  }
	  .ActiveComBtn {
	    background-color: #118EF2;
	    cursor: pointer;
	  }
	  .stOrNew {
	    width: 100%;
	    display: flex;
	    justify-content: space-between;
	  }
	  .defaultBtn {
	    width: 120px;
	    color: #fff;
	    border-radius: 20px;
	    text-align: center;
	    line-height: 35px;
	    height: 35px;
	    cursor: pointer;
	  }
	  .newPrict {
	    background-color: #008000;
	    margin-left: 20px;
	  }
	  .stopPrict {
	    background-color: #FF0000;
	  }
	  .handBox {
	    margin-top: 50px;
	  }
	}
}
</style>


// WEBPACK FOOTER //
// ./src/page/newVoiceScene/index.vue